import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Button } from '@querodelivery/uni-react';
import { getWhatsappUrl } from '../../utils';
import styles from './talk-to-deliveryman.module.scss';

interface TalkToDeliverymanButtonProps {
  phone: string;
}

export function TalkToDeliverymanButton({
  phone,
}: TalkToDeliverymanButtonProps) {
  function handleClick() {
    window.open(getWhatsappUrl(phone), '_blank', 'noopener,noreferrer');
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      width="full"
      className={styles.button}
      icon={<FontAwesomeIcon icon={faWhatsapp} className={styles.icon} />}
      onClick={handleClick}
    >
      Falar com entregador
    </Button>
  );
}
